
export default function () {
  $('.block--featured-resources').each(function () {
    const block = $(this);
    
    block.find('.basic-tabs__tab-button').on('click', function () {
      let tab = $(this).data('tab-contents-id');
      
      block
        .find('.basic-tabs__tab-button')
        .removeClass('--active');
      $(this).addClass('--active');
      
      block
        .find('.featured-resources__tab-content')
        .removeClass('featured-resources__tab-content--active')
      .hide();
      
      const $activeTabContent = block.find(`.featured-resources__tab-content[data-tab-contents-id="${tab}"]`);
      
      $activeTabContent.addClass('featured-resources__tab-content--active');
      $activeTabContent.show();
    });
    
    block.find('.basic-tabs__tab-buttons-mobile .dropdown-menu__button').on('change', function () {
      let tab = $(this).val();
      
      block
        .find('.featured-resources__tab-content')
        .removeClass('featured-resources__tab-content--active')
        .hide();
      
      const $activeTabContent = block.find(`.featured-resources__tab-content[data-tab-contents-id="${tab}"]`);
      
      $activeTabContent.addClass('featured-resources__tab-content--active');
      $activeTabContent.show();
      
      // Set swipe view.
      block.find('.tabs--swipe-stack > *').removeClass('--active');
      block.find('.tabs--swipe-stack [data-tab-contents-id="swipe-stack-0"]').addClass('--active');
      swipeOption(block);
    });
    
    block.find('.basic-tabs__tab-buttons-mobile .tabs--swipe-stack .tabs--swipe-stack-button').on('click', function () {
      let tab = $(this).data('tab-contents-id');
      
      block
        .find('.tabs--swipe-stack-button')
        .removeClass('--active');
      $(this).addClass('--active');
      
      if (tab == "swipe-stack-1") {
        stackOption(block);
      }
      
      if (tab == "swipe-stack-0") {
        swipeOption(block);
      }
    });
    
    const $firstTab = block.find('.basic-tabs__tab-button').first();
    if ($firstTab.length > 0) {
      $firstTab.trigger('click');
      block
        .find('.featured-resources__tab-content--active')
        .removeClass('stack')
        .addClass('swipe');
      
      swipeOption(block);
    }

    $('#resourceFilter').on('change', function () {
      block
        .find(`.basic-tabs__tab-buttons-desktop .basic-tabs__tab-button[data-tab-contents-id="${$(this).val()}"]`)
        .trigger('click');

      setTimeout(function () {
        block
          .find('.tabs--swipe-stack-button.--active')
          .trigger('click');
      }, 100);
    });

  });
  
  // Function to initialize the Slick slider inside each tab
  function initializeSlick($slider) {
    if ($slider.length > 0) {
      if ($slider.hasClass('slick-initialized')) {
        $slider.slick('unslick');
      }
      $slider.addClass('slick');
      
      $slider.slick({
        dots: true,
        arrows: true,
        infinite: false,
        slidesToShow: 2,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 665,
                settings: {
                    slidesToShow: 1
                }
            },
        ],
        
      });
    }
  }

  // UnInit slick.
  function destroySlick($slider) {
    if ($slider.length && $slider.hasClass('slick-initialized') && typeof $slider.slick === 'function') {
      $slider.slick('unslick');
    }
  }
  
  // Add Swipe Option.
  function swipeOption(block) {
    block
      .find('.featured-resources__tab-content--active')
      .removeClass('stack')
      .addClass('swipe');
    
    if (isMobile()) {
      // Init Slick.
      initializeSlick(block.find('.featured-resources__tab-content--active.swipe .featured-resources__cards'));
    }
  }
  
  // Add Stack Option.
  function stackOption(block) {
    block
      .find('.featured-resources__tab-content--active')
      .removeClass('swipe')
      .addClass('stack');
    
    // Destroy Slick.
    destroySlick(block.find('.featured-resources__cards'));
  }
  
  function isMobile() {
    if ( $('.featured-resources__cards').css('display') == 'flex' ) {
      return true;
    }
  }
  
  
  $(window).on('resize', function () {
    $('.block--featured-resources').each(function () {
      const $this = $(this);
      const $cards = $this.find('.featured-resources__cards');
  
      // Safely unslick before deciding on swipe or stack
      //destroySlick($cards);
  
      const activeTab = $this.find('.tabs--swipe-stack-button.--active').data('tab-contents-id');
      if ($cards.css('display') === 'flex') {
        if (activeTab === 'swipe-stack-0') {
          swipeOption($this);
        } else {
          stackOption($this);
        }
      } else {
        stackOption($this);
      }
    });
  });
}

